import SignalTypes from "../models/SignalTypes";
import AddressGeneratorUtils from "./AddressGeneratorUtils";

export default function linkSceneSignals() {
    ////////////////////////////////////////////////////////////////////////////////
    //
    // Assign Scene-GroupAddress to all Scene Signals
    //    Scene-GroupAddress is fix: 31/0/0
    //
    ////////////////////////////////////////////////////////////////////////////////

    const sceneAddress = state.addresses.findFirst((a) => a.address == "31")?.children.findFirst((a) => a.address == "0")?.children.findFirst((a) => a.address == "0"); // GroupAddress "31/0/0"

    if (!sceneAddress) {
        console.error("Scene-GroupAddress not found");
        return;
    }

    state.allDevices().forEach((device) => {
        device.knxChannels.forEach((knxChannel) => {
            knxChannel.signals.forEach((knxSignal) => {
                if (knxSignal.type.name == SignalTypes.Scene.name) {
                    AddressGeneratorUtils.attachGroupAddressToSignal(knxSignal, sceneAddress);
                }
            });
        });
    });


}